import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../../assets/logo.png";

const MainHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Detect scroll for adding blur effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const menuItems = [
    { name: "Home", path: "/home" },
    { name: "Rooms", path: "/rooms" },
    { name: "About Us", path: "/about-us" },
    { name: "Contact", path: "/contact-us" },
  ];

  return (
    <header
      className={` w-full z-50 transition-all bg-lightprimary duration-300 `}
    >
      <div className="container mx-auto flex justify-between items-center py-4 px-4 md:px-8">
        {/* Logo */}
        <div className="flex items-center">
          <Link to="/home">
            <img src={logo} className="h-12" alt="Gold Palace Inn Logo" />
          </Link>
        </div>

        {/* Menu Items (Large Screen) */}
        <nav className="hidden lg:flex space-x-6">
          {menuItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              className={({ isActive }) =>
                `relative font-semibold font-k2d text-base ${
                  isActive
                    ? "text-primary after:content-[''] after:absolute after:left-0 after:right-0 after:bottom-[-2px] after:h-[2px] after:bg-primary after:transition-all after:duration-300"
                    : "text-secondary hover:text-primary hover:after:content-[''] hover:after:absolute hover:after:left-0 hover:after:right-0 hover:after:bottom-[-2px] hover:after:h-[2px] hover:after:bg-primary hover:after:transition-all hover:after:duration-300"
                }`
              }
            >
              {item.name}
            </NavLink>
          ))}
        </nav>

        {/* Reservation Button */}
        <div className="hidden lg:block">
          <button
            className="px-4 py-2 border border-primary text-primary font-semibold rounded hover:bg-white hover:text-gray-900 transition-all"
            onClick={() => {
              const PHONENUMBER = process.env.REACT_APP_PHONENUMBER;
              const message = `
Hello,

I am interested in booking the Hotel Room at Gold Palace Inn & Banquet for an upcoming event. Could you please provide more details about the availability, pricing, and facilities?

Thank you!
`;
              const encodedMessage = encodeURIComponent(message.trim());
              const whatsappURL = `https://wa.me/${PHONENUMBER}?text=${encodedMessage}`;
              window.open(whatsappURL, "_blank");
            }}
          >
            Book Now
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <div className="block lg:hidden">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle Menu"
            className="text-white focus:outline-none"
          >
            {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Full-Screen Menu */}
      {menuOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex flex-col items-center justify-center backdrop-blur-md">
          {menuItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              className="text-2xl text-white mb-4 font-semibold hover:underline"
              onClick={() => setMenuOpen(false)}
            >
              {item.name}
            </NavLink>
          ))}
          <button
            className="bg-primary text-white font-libre font-medium text-xl mt-5 py-3 px-6 rounded-lg shadow-md hover:bg-yellow-600"
            onClick={() => {
              const PHONENUMBER = process.env.REACT_APP_PHONENUMBER;
              const message = `
Hello,

I am interested in booking the Banquet Hall at Gold Palace Inn for an upcoming event. Could you please provide more details about the availability, pricing, and facilities?

Thank you!
`;
              const encodedMessage = encodeURIComponent(message.trim());
              const whatsappURL = `https://wa.me/${PHONENUMBER}?text=${encodedMessage}`;
              window.open(whatsappURL, "_blank");
            }}
          >
            Book Now
          </button>
        </div>
      )}
    </header>
  );
};

export default MainHeader;
